// extracted by mini-css-extract-plugin
export default {"root":"IconReviewStar_root__NkRWj","filled":"IconReviewStar_filled__YwO4D"};